import store from "utils/store";

const updateOnlineStatus=(status)=>{
  store.dispatch({type: "CHANGE_ONLINE_STATUS", online: status})
}
window.addEventListener('online',  () => updateOnlineStatus(true));
window.addEventListener('offline', () => updateOnlineStatus(false));

export default ()=>{
  store.dispatch({type: "CHANGE_ONLINE_STATUS", online: window.navigator.onLine})
}



// WEBPACK FOOTER //
// ./src/online.js